import flagKeys from '@/constants/flagKeys';
import CoinImage from '@/views/YourCoin/CoinImage/Coin2dEdit.vue';
import { Route } from '../route.model';
import { IBusinessType } from '@/models/business';

const coinImage = new Route('/coin/image', 'coin_image', CoinImage, {
  isResponsive: flagKeys.responsiveDashboard,
  requiresAuth: true,
  navbar: {
    name: 'Reward Coin Image', // TODO apply i18n
    icon: 'branded-coin',
    description:
      'Design your own unique Coin using colors to match your branding.'
  },
  pageView: {
    eventLabel: 'Coin Image'
  },
  zendesk: {
    desktop: {
      position: 'bl'
    },
    mobile: {
      position: 'bl'
    }
  },
  feature: {
    type: IBusinessType.BOTH,
    title: 'Customize Coin'
  }
});

export { coinImage };
export default coinImage;
